import { UserTypes } from '@/components/common/Providers/GraphqlProvider/generated';
import { permissionsKeys as DynamicPagesPermissionsKeys } from '@/components/views/Admin/private/ContentManagement/DynamicPages/PermissionsKey';
import { permissionsKeys as EventsPermissionsKeys } from '@/components/views/Admin/private/ContentManagement/EventsAdm/PermissionsKey';
import { permissionsKeys as InstitutionalProgramsContentManagementPermissionsKeys } from '@/components/views/Admin/private/ContentManagement/InstitutionalProgramsContent/PermissionsKey';
import { permissionsKeys as ParticipateContentManagementPermissionsKeys } from '@/components/views/Admin/private/ContentManagement/ParticipateContent/PermissionsKey';
import { permissionsKeys as PqrsdContentManagementPermissionsKeys } from '@/components/views/Admin/private/ContentManagement/PqrsdAction/PermissionsKey';
import { permissionsKeys as PressRoomContentManagementPermissionsKeys } from '@/components/views/Admin/private/ContentManagement/PressRoomManagement/PermissionsKey';
import {
  permissionsKeys as ProceduresAndServicesContentManagementPermissionsKeys,
  permissionsKeys as ProceduresAndServicesPermissionsKeys,
} from '@/components/views/Admin/private/ContentManagement/ProceduresAndServices/PermissionsKey';
import { permissionsKeys as RegulationsContentManagementPermissionsKeys } from '@/components/views/Admin/private/ContentManagement/Regulation/PermissionsKey';
import { permissionsKeys as DependenciesPermissionsKeys } from '@/components/views/Admin/private/Dependencies/PermissionsKeys';
import { permissionsKeys as DocumentsContentManagementPermissionsKeys } from '@/components/views/Admin/private/Documents/PermissionsKeys';
import { permissionsKeys as FooterObjectsPermissionsKeys } from '@/components/views/Admin/private/FooterObjects/PermissionsKey';
import { permissionsKeys as headerObjectsPermissionsKeys } from '@/components/views/Admin/private/HeaderObjects/PermissionsKey';
import { permissionsKeys as HomePagePermissionsKeys } from '@/components/views/Admin/private/HomePage/PermissionsKey';
import { permissionsKeys as InstitutionalProgramsPermissionsKeys } from '@/components/views/Admin/private/PageInstitutionalProgram/PermissionsKey';
import { permissionsKeys as ParticipatesPagePermissionsKeys } from '@/components/views/Admin/private/PageParticipates/PermissionsKey';
import { permissionsKeys as PqrsdPermissionsKeys } from '@/components/views/Admin/private/PagePqrsd/PermissionsKey';
import { permissionsKeys as PressRoomPermissionsKeys } from '@/components/views/Admin/private/PagePressRoom/PermissionsKey';
import { permissionsKeys as RegulationsPermissionsKeys } from '@/components/views/Admin/private/PageRegulations/PermissionsKey';
import { permissionsKeys as ParametersPermissionsKeys } from '@/components/views/Admin/private/Parameters/PermissionsKey';
import { permissionsKeys as PositionsPermissionsKeys } from '@/components/views/Admin/private/Positions/PermissionsKeys';
import { permissionsKeys as SecurityPermissionsKeys } from '@/components/views/Admin/private/Security/PermissionsKey';
import { permissionsKeys as ThemesPermissionsKeys } from '@/components/views/Admin/private/Themes/PermissionsKey';
import { permissionsKeys as TransparencyPermissionsKeys } from '@/components/views/Admin/private/Transparency/PermissionsKey';
import { permissionsKeys as VersionPagePermissionsKeys } from '@/components/views/Admin/private/VersionPage/PermissionsKey';

import { permissionsKeys as ContentManagementPermissionsKeys } from '../components/views/Admin/private/ContentManagement/PermissionsKey';
import { permissionsKeys as CustomSitePermissionsKeys } from '../components/views/Admin/private/CustomSites/PermissionsKey';
import { permissionsKeys as DynamicListDocumentsTypesPermissionsKeys } from '../components/views/Admin/private/DynamicList/DocumentTypes/PermissionsKeys';
import { permissionsKeys as DynamicListEventsGroupsPermissionsKeys } from '../components/views/Admin/private/DynamicList/EventsGroups/PermissionsKeys';
import { permissionsKeys as DynamicListNewsGroupsPermissionsKeys } from '../components/views/Admin/private/DynamicList/NewsGroups/PermissionsKeys';
import { permissionsKeys as DynamicListPermissionsKeys } from '../components/views/Admin/private/DynamicList/PermissionsKeys';
import { permissionsKeys as MicroSitePermissionsKeys } from '../components/views/Admin/private/DynamicPage/PermissionsKey';
import { permissionsKeys as TemplatesPermissionsKeys } from '../modules/Template/permissionsKeys';
import {
  ROUTE_ADMIN_CONFIG_PAGE_INSTITUTIONAL_PROGRAMS,
  ROUTE_ADMIN_CONFIG_PAGE_ROOM,
  ROUTE_ADMIN_PARTICIPATES_PAGE,
  ROUTE_ADMIN_REGULATIONS_PAGE,
  ROUTE_ADMIN_SERVICES_PAGE,
  ROUTE_ADMIN_TEMPLATES,
  ROUTE_ADMIN_TRANSPARENCY_PAGE,
} from './constants';

interface RoutePermission {
  path: string;
  permission: string;
}

export const ROUTE_PERMISSIONS: RoutePermission[] = [
  {
    path: '/admin/home/admin-version-page/version-page',
    permission: VersionPagePermissionsKeys.adminVersionFind, //✅ Nuevos permisos
  },
  //---------------------------CONFIG PAGE--------------------------------------
  {
    path: '/admin/home/page-config/header-objects',
    permission: headerObjectsPermissionsKeys.pageBlockFind,
  },
  {
    path: '/admin/home/page-config/footer-objects',
    permission: FooterObjectsPermissionsKeys.pageBlockFind,
  },
  {
    path: '/admin/home/page-config/home-page',
    permission: HomePagePermissionsKeys.pageBlockFind,
  },
  //--------------------------NAVIGATION PAGE--------------------------------
  {
    path: ROUTE_ADMIN_TRANSPARENCY_PAGE, //✅ New system route
    permission: TransparencyPermissionsKeys.pageBlockFind,
  },
  {
    path: ROUTE_ADMIN_SERVICES_PAGE, //✅ New system route
    permission: ProceduresAndServicesPermissionsKeys.pageBlockFind,
  },
  {
    path: ROUTE_ADMIN_PARTICIPATES_PAGE, //✅ New system route
    permission: ParticipatesPagePermissionsKeys.pageBlockFind,
  },
  {
    path: ROUTE_ADMIN_CONFIG_PAGE_ROOM, //✅ New system route
    permission: PressRoomPermissionsKeys.pageBlockFind,
  },
  {
    path: ROUTE_ADMIN_CONFIG_PAGE_INSTITUTIONAL_PROGRAMS, //✅ New system route
    permission: InstitutionalProgramsPermissionsKeys.pageBlockFind,
  },
  {
    path: ROUTE_ADMIN_REGULATIONS_PAGE, //✅ New system route
    permission: RegulationsPermissionsKeys.pageBlockFind,
  },
  {
    path: '/admin/home/pqrsd',
    permission: PqrsdPermissionsKeys.pageBlockFind,
  },
  {
    path: '/admin/home/parametrization/micro-sites',
    permission: MicroSitePermissionsKeys.pageBlockFind,
  },
  {
    path: '/admin/home/micro-sites/custom-sites',
    permission: CustomSitePermissionsKeys.pageBlockFind,
  },
  {
    path: '/admin/home/micro-sites/dynamic-page',
    permission: MicroSitePermissionsKeys.pageBlockFind,
  },
  {
    path: ROUTE_ADMIN_TEMPLATES,
    permission: TemplatesPermissionsKeys.pageBlockFind,
  },

  //----------------------------Content Management----------------------------
  {
    path: '/admin/home/content-management/documents',
    permission: DocumentsContentManagementPermissionsKeys.pageBlockFind,
  },
  {
    path: '/admin/home/content-management/procedures-and-services',
    permission: ProceduresAndServicesContentManagementPermissionsKeys.pageBlockFind,
  },
  {
    path: '/admin/home/content-management/participate',
    permission: ParticipateContentManagementPermissionsKeys.pageBlockFind,
  },
  {
    path: '/admin/home/content-management/regulation',
    permission: RegulationsContentManagementPermissionsKeys.pageBlockFind,
  },
  {
    path: '/admin/home/content-management/news-management',
    permission: PressRoomContentManagementPermissionsKeys.pageBlockFind,
  },
  {
    path: '/admin/home/content-management/events',
    permission: EventsPermissionsKeys.pageBlockFind,
  },
  {
    path: '/admin/home/content-management/institutional-programs-management',
    permission: InstitutionalProgramsContentManagementPermissionsKeys.pageBlockFind,
  },
  {
    path: '/admin/home/content-management/dynamic-pages',
    permission: DynamicPagesPermissionsKeys.pageBlockFind,
  },
  {
    path: '/admin/home/content-management/pqrsd',
    permission: PqrsdContentManagementPermissionsKeys.pageBlockFind,
  },
  {
    path: '/admin/home/content-management',
    permission: ContentManagementPermissionsKeys.page,
  },
  // ---------------------------Parametrization----------------------------
  {
    path: '/admin/home/parametrization/parameters',
    permission: ParametersPermissionsKeys.pageBlockFind,
  },
  {
    path: '/admin/home/parametrization/themes',
    permission: ThemesPermissionsKeys.page,
  },
  //--------------------Parametrization - Security--------------------------
  {
    path: '/admin/home/parametrization/security',
    permission: SecurityPermissionsKeys.page,
  },
  {
    path: '/admin/home/parametrization/security/role-management',
    permission: SecurityPermissionsKeys.pageRolsManagement,
  },
  {
    path: '/admin/home/parametrization/security/account-users',
    permission: SecurityPermissionsKeys.pagePublicUsers,
  },
  {
    path: '/admin/home/parametrization/security/account-users-admin',
    permission: SecurityPermissionsKeys.pageAdminUsers,
  },
  {
    path: '/admin/home/parametrization/security/system-audit',
    permission: SecurityPermissionsKeys.pageSystemAudit,
  },
  {
    path: '/admin/home/parametrization/dependencies',
    permission: DependenciesPermissionsKeys.pageBlockFind,
  },
  {
    path: '/admin/home/parametrization/positions',
    permission: PositionsPermissionsKeys.pageBlockFind,
  },
  {
    path: '/admin/home/parametrization/dynamic-list',
    permission: DynamicListPermissionsKeys.pageBlockFind,
  },
  {
    path: '/admin/home/parametrization/dynamic-list/document-types',
    permission: DynamicListDocumentsTypesPermissionsKeys.pageBlockFind,
  },
  {
    path: '/admin/home/parametrization/dynamic-list/news-groups',
    permission: DynamicListNewsGroupsPermissionsKeys.pageBlockFind,
  },
  {
    path: '/admin/home/parametrization/dynamic-list/events-groups',
    permission: DynamicListEventsGroupsPermissionsKeys.pageBlockFind,
  },
];
